(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterAccordionBlock extends HTMLElement {
    constructor() {
      super();

      this.toggleBtn = null;
      this.content = null;
      this.blockType = this.dataset.blockType;
    }

    connectedCallback() {
      if (this.blockType === 'brand_information') return;

      this.toggleBtn = this.querySelector('.footer-accordion__toggle');
      this.content = this.querySelector('.footer-accordion__content');

      if (!this.toggleBtn || !this.content) return;

      if (!this.isMobile()) {
        this.open();
        return;
      }

      this.close();

      this.toggleBtn.addEventListener('click', () => {
        this.isOpen() ? this.close() : this.open();
      });
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    open() {
      this.classList.add('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      this.content.style.display = 'block';
    }

    close() {
      this.classList.remove('is-open');
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      this.content.style.display = 'none';
    }
  }

  customElements.define('footer-accordion-block', FooterAccordionBlock);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-phaf-works"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('phaf-how-it-works')) {
    customElements.define(
      'phaf-how-it-works',
      class PhafHowItWorks extends HTMLElement {
        constructor() {
          super();
          this._onEnter = this.onMouseEnter.bind(this);
          this._onLeave = this.onMouseLeave.bind(this);
        }

        connectedCallback() {
          this.steps = this.querySelectorAll('[data-step]');

          this.steps.forEach((step) => {
            step.addEventListener('mouseenter', this._onEnter);
            step.addEventListener('mouseleave', this._onLeave);
          });
        }

        disconnectedCallback() {
          this.steps?.forEach((step) => {
            step.removeEventListener('mouseenter', this._onEnter);
            step.removeEventListener('mouseleave', this._onLeave);
          });
        }

        onMouseEnter(e) {
          const video = e.currentTarget.querySelector('video');
          if (!video) return;

          video.play().catch(() => {});
        }

        onMouseLeave(e) {
          const video = e.currentTarget.querySelector('video');
          if (!video) return;

          video.pause();
          video.currentTime = 0;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phaf-horizontal-carousel"] && !Shopify.designMode) return;
  try {
    
  class PhafProductsSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
   
      if (this.swiper) return;

      if (!window.Swiper) {
        console.warn('[PHAF] Swiper not available');
        return;
      }

      const container = this.querySelector('.phaf-products-swiper');
      if (!container) return;

      const nextBtn = container.querySelector('.swiper-button-next');
      const prevBtn = container.querySelector('.swiper-button-prev');

      this.swiper = new window.Swiper(container, {
        modules: window.SwiperModules ? [window.SwiperModules.Navigation] : [],

        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,

        breakpoints: {
          576: { slidesPerView: 'auto' },
          768: { slidesPerView: 'auto' },
          1200: { slidesPerView: 'auto' },
        },

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('phaf-products-swiper', PhafProductsSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phaf-reviews"] && !Shopify.designMode) return;
  try {
    
  class PhafReviewsSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      if (this.swiper) return;

      if (!window.Swiper) {
        console.warn('[PHAF Reviews] Swiper not available');
        return;
      }

      const container = this.querySelector('.phaf-reviews-swiper');
      if (!container) return;

      const nextBtn = container.querySelector('.swiper-button-next');
      const prevBtn = container.querySelector('.swiper-button-prev');

      this.swiper = new window.Swiper(container, {
        modules: window.SwiperModules ? [window.SwiperModules.Navigation] : [],

        slidesPerView: 1.4,
        spaceBetween: 20,
        loop: true,

        breakpoints: {
          576: { slidesPerView: 1.6 },
          768: { slidesPerView: 2.2 },
          1200: { slidesPerView: 2.8 },
        },
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('phaf-reviews-swiper', PhafReviewsSwiper);

  } catch(e) { console.error(e); }
})();
})();
